import QuantityChanger from './QuantityChanger'

export default QuantityChanger
